<div class="container-fluid px-2 px-sm-4 py-3" style="padding-bottom:calc(48px + env(safe-area-inset-bottom, 0px) + 32px);">

  <!-- Mobile tab navigation -->
  <nav class="d-md-none mb-3">
    <div class="d-flex nav-pills-mobile" style="background:var(--bs-tertiary-bg);border-radius:10px;padding:3px;gap:3px;overflow-x:auto;-webkit-overflow-scrolling:touch;scrollbar-width:none;">
      <button class="nav-tab-btn flex-shrink-0 py-2 px-3 rounded-3 border-0 small fw-semibold"
              [class.active]="activeTab==='energie'"
              (click)="setTab('energie')">⚡ {{ 'TAB_ENERGIE' | translate }}</button>
      <button class="nav-tab-btn flex-shrink-0 py-2 px-3 rounded-3 border-0 small fw-semibold"
              [class.active]="activeTab==='klima'"
              (click)="setTab('klima')">🌡 {{ 'TAB_KLIMA' | translate }}</button>
      <button class="nav-tab-btn flex-shrink-0 py-2 px-3 rounded-3 border-0 small fw-semibold"
              [class.active]="activeTab==='heizung'"
              (click)="setTab('heizung')">🔥 {{ 'TAB_HEIZUNG' | translate }}</button>
      <button class="nav-tab-btn flex-shrink-0 py-2 px-3 rounded-3 border-0 small fw-semibold"
              [class.active]="activeTab==='zisterne'"
              (click)="setTab('zisterne')">💧 {{ 'TAB_WASSER' | translate }}</button>
      <button class="nav-tab-btn flex-shrink-0 py-2 px-3 rounded-3 border-0 small fw-semibold"
              [class.active]="activeTab==='muell'"
              (click)="setTab('muell')">🗑️ {{ 'TAB_MUELL' | translate }}</button>
      <button class="nav-tab-btn flex-shrink-0 py-2 px-3 rounded-3 border-0 small fw-semibold"
              [class.active]="activeTab==='netzwerk'"
              (click)="setTab('netzwerk')">🌐 {{ 'TAB_NETZ' | translate }}</button>
      <button class="nav-tab-btn flex-shrink-0 py-2 px-3 rounded-3 border-0 small fw-semibold"
              [class.active]="activeTab==='statistik'"
              (click)="setTab('statistik')">📊 {{ 'TAB_STATISTIK' | translate }}</button>
    </div>
  </nav>

  <!-- ═══ ENERGIE ═══ -->
  <div *ngIf="!isMobileView || activeTab === 'energie'">
    <app-energie
      [solar]="solar"
      [solarHistory]="solarHistory"
      [solarFlash]="solarFlash"
      [liveDotOn]="liveDotOn"
      [solarUpdatedAt]="solarUpdatedAt"
      [nowTick]="nowTick"
      [todayStat]="todayStat"
      [darkMode]="darkMode"
      (openSolarChart)="openSolarChart()">
    </app-energie>
  </div>

  <!-- ═══ KLIMA ═══ -->
  <div *ngIf="!isMobileView || activeTab === 'klima'">
    <app-klima
      [thermometers]="thermometers"
      [thermometerHistory]="thermometerHistory"
      [thermoFlash]="thermoFlash"
      [liveDotOn]="liveDotOn"
      [thermoUpdatedAt]="thermoUpdatedAt"
      [nowTick]="nowTick"
      [darkMode]="darkMode">
    </app-klima>
  </div>

  <!-- ═══ HEIZUNG ═══ -->
  <div *ngIf="!isMobileView || activeTab === 'heizung'">
    <app-heizung
      [froeling]="froeling"
      [froelingHistory]="froelingHistory"
      [froelingFlash]="froelingFlash"
      [liveDotOn]="liveDotOn"
      [froelingUpdatedAt]="froelingUpdatedAt"
      [nowTick]="nowTick"
      [darkMode]="darkMode"
      [pelletStats]="pelletStats"
      (openHeizungChart)="openHeizungChart()">
    </app-heizung>
  </div>

  <!-- ═══ ZISTERNE ═══ -->
  <div *ngIf="!isMobileView || activeTab === 'zisterne'">
    <app-zisterne
      [zisterne]="zisterne"
      [zisterneHistory]="zisterneHistory"
      [zisterneFlash]="zisterneFlash"
      [liveDotOn]="liveDotOn"
      [zisterneUpdatedAt]="zisterneUpdatedAt"
      [nowTick]="nowTick"
      [darkMode]="darkMode">
    </app-zisterne>
  </div>

  <!-- ═══ MÜLL ═══ -->
  <div *ngIf="!isMobileView || activeTab === 'muell'">
    <app-muell
      [nextPickupsByType]="nextPickupsByType"
      [wastePickups]="wastePickups"
      [loading]="!wasteLoaded"
      [darkMode]="darkMode">
    </app-muell>
  </div>

  <!-- ═══ STATISTIK ═══ -->
  <div *ngIf="!isMobileView || activeTab === 'statistik'">
    <app-statistik
      [stats]="stats"
      [pelletStats]="pelletStats"
      [loading]="!statsLoaded"
      [darkMode]="darkMode">
    </app-statistik>
  </div>

  <!-- ═══ NETZWERK ═══ -->
  <div *ngIf="!isMobileView || activeTab === 'netzwerk'">
    <app-netzwerk
      [unifi]="unifi"
      [unifiTimedOut]="unifiTimedOut"
      [darkMode]="darkMode">
    </app-netzwerk>
  </div>

</div>

<!-- Footer -->
<footer class="fixed-bottom bg-body-tertiary border-top d-flex align-items-center px-3 flex-nowrap gap-2"
        style="height:48px;z-index:1030;">
  <span class="text-muted small me-auto text-nowrap overflow-hidden" style="min-width:0;">
    © {{ currentYear }}
    <span class="d-none d-sm-inline">blonkel.com</span>
    &nbsp;|&nbsp;<code style="cursor:pointer;" (click)="openChangelog()" title="Changelog">{{ shortHash(frontendCommit) }}</code>
    <span class="d-none d-sm-inline">&nbsp;|&nbsp;<code style="cursor:pointer;" (click)="openChangelog()" title="Changelog">{{ shortHash(vs.backendCommit) || '…' }}</code></span>
  </span>
  <span class="text-muted small text-nowrap flex-shrink-0" [title]="'OFFENE_WEBSOCKET' | translate">
    {{ vs.connectedClients }} 👥
  </span>
  <!-- Dark mode toggle -->
  <button class="btn btn-sm btn-outline-secondary flex-shrink-0 px-2 ms-1" (click)="toggleDarkMode()"
          [title]="(darkMode ? 'LIGHT_MODE' : 'DARK_MODE') | translate" style="line-height:1;">
    <svg *ngIf="darkMode" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
      <path d="M8 11a3 3 0 1 1 0-6 3 3 0 0 1 0 6m0 1a4 4 0 1 0 0-8 4 4 0 0 0 0 8M8 0a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0v-2A.5.5 0 0 1 8 0m0 13a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0v-2A.5.5 0 0 1 8 13m8-5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1 0-1h2a.5.5 0 0 1 .5.5M3 8a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1 0-1h2A.5.5 0 0 1 3 8m10.657-5.657a.5.5 0 0 1 0 .707l-1.414 1.415a.5.5 0 1 1-.707-.708l1.414-1.414a.5.5 0 0 1 .707 0m-9.193 9.193a.5.5 0 0 1 0 .707L3.05 13.657a.5.5 0 0 1-.707-.707l1.414-1.414a.5.5 0 0 1 .707 0m9.193 2.121a.5.5 0 0 1-.707 0l-1.414-1.414a.5.5 0 0 1 .707-.707l1.414 1.414a.5.5 0 0 1 0 .707M4.464 4.465a.5.5 0 0 1-.707 0L2.343 3.05a.5.5 0 1 1 .707-.707l1.414 1.414a.5.5 0 0 1 0 .708"/>
    </svg>
    <svg *ngIf="!darkMode" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
      <path d="M6 .278a.77.77 0 0 1 .08.858 7.2 7.2 0 0 0-.878 3.46c0 4.021 3.278 7.277 7.318 7.277q.792-.001 1.533-.16a.79.79 0 0 1 .81.316.73.73 0 0 1-.031.893A8.35 8.35 0 0 1 8.344 16C3.734 16 0 12.286 0 7.71 0 4.266 2.114 1.312 5.124.06A.75.75 0 0 1 6 .278"/>
    </svg>
  </button>
  <!-- Language switcher -->
  <button class="btn btn-sm btn-outline-secondary flex-shrink-0 px-2" (click)="openLangPicker()" [title]="'SPRACHE' | translate">
    <span class="emoji-flag">{{ currentLangFlag }}</span>
  </button>
  <a class="btn btn-sm btn-outline-secondary flex-shrink-0" href="/3d/" target="_blank" rel="noopener" title="3D-Ansicht">
    🏠 3D
  </a>
  <button class="btn btn-sm btn-outline-secondary flex-shrink-0" (click)="openApiDocs()" title="API">
    🔌 API
  </button>
  <button class="btn btn-sm btn-outline-secondary flex-shrink-0" (click)="toggleAdmin()">
    ⚙️ Admin
  </button>
</footer>

<!-- Admin Overlay -->
<div *ngIf="adminOpen"
     style="position:fixed;inset:0;z-index:1050;display:flex;align-items:center;justify-content:center;background:rgba(0,0,0,0.5);"
     (click)="closeAdmin()">

  <div class="bg-body shadow-lg d-flex flex-column"
       style="width:calc(100vw - 32px);height:calc(100vh - 32px);border-radius:8px;overflow:hidden;"
       (click)="$event.stopPropagation()">

    <!-- Header -->
    <div class="d-flex align-items-center gap-2 px-3 py-2 border-bottom flex-shrink-0">
      <span class="fw-semibold me-auto">⚙️ Admin</span>
      <button *ngIf="logAuthenticated" class="btn btn-sm btn-outline-danger" (click)="adminLogout()">Logout</button>
      <button class="btn btn-sm btn-outline-secondary" (click)="closeAdmin()">✕</button>
    </div>

    <!-- Not authenticated: password prompt only, no navigation hints -->
    <div *ngIf="!logAuthenticated"
         class="flex-grow-1 d-flex align-items-center justify-content-center p-4">
      <div style="max-width:320px;width:100%;">
        <div *ngIf="logAuthError" class="alert alert-danger py-2 small mb-3">{{ 'FALSCHES_PASSWORT' | translate }}</div>
        <label class="form-label fw-semibold">{{ 'PASSWORT' | translate }}</label>
        <div class="input-group">
          <input type="password" class="form-control" [(ngModel)]="logPassword"
                 [placeholder]="'LOGS_PASSWORT' | translate"
                 (keydown.enter)="submitLogPassword()">
          <button class="btn btn-primary" (click)="submitLogPassword()">{{ 'OEFFNEN' | translate }}</button>
        </div>
      </div>
    </div>

    <!-- Authenticated: full navigation + content -->
    <ng-container *ngIf="logAuthenticated">

      <!-- Mobile tab strip -->
      <div class="d-flex d-md-none border-bottom flex-shrink-0" style="overflow-x:auto;">
        <button class="btn btn-sm px-3 py-2 rounded-0 border-0 flex-shrink-0"
                [class.fw-semibold]="adminSection === 'logs'"
                [style.border-bottom]="adminSection === 'logs' ? '2px solid var(--bs-primary)' : '2px solid transparent'"
                (click)="setAdminSection('logs')">
          🗒 {{ 'LOGS' | translate }}
        </button>
        <button class="btn btn-sm px-3 py-2 rounded-0 border-0 flex-shrink-0"
                [class.fw-semibold]="adminSection === 'clients'"
                [style.border-bottom]="adminSection === 'clients' ? '2px solid var(--bs-primary)' : '2px solid transparent'"
                (click)="setAdminSection('clients')">
          🔌 Clients
        </button>
      </div>

      <!-- Body: sidebar + content -->
      <div class="d-flex flex-row flex-grow-1 overflow-hidden">

        <!-- Desktop sidebar -->
        <nav class="d-none d-md-flex flex-column border-end flex-shrink-0 py-2" style="width:160px;">
          <button class="btn btn-sm text-start px-3 py-2 rounded-0 border-0"
                  [class.fw-semibold]="adminSection === 'logs'"
                  [class.bg-primary-subtle]="adminSection === 'logs'"
                  (click)="setAdminSection('logs')">
            🗒 {{ 'LOGS' | translate }}
          </button>
          <button class="btn btn-sm text-start px-3 py-2 rounded-0 border-0"
                  [class.fw-semibold]="adminSection === 'clients'"
                  [class.bg-primary-subtle]="adminSection === 'clients'"
                  (click)="setAdminSection('clients')">
            🔌 Clients
          </button>
        </nav>

        <!-- Section content -->
        <div class="flex-grow-1 overflow-hidden d-flex flex-column" [ngSwitch]="adminSection">

          <!-- ── Logs ── -->
          <ng-container *ngSwitchCase="'logs'">

            <div class="d-flex align-items-center gap-2 px-3 py-2 border-bottom flex-shrink-0">
              <div class="btn-group btn-group-sm me-auto" role="group">
                <button type="button" class="btn"
                        [class.btn-secondary]="logLevel === 'all'"
                        [class.btn-outline-secondary]="logLevel !== 'all'"
                        (click)="setLogLevel('all')">{{ 'ALLE' | translate }}</button>
                <button type="button" class="btn"
                        [class.btn-secondary]="logLevel === 'low'"
                        [class.btn-outline-secondary]="logLevel !== 'low'"
                        (click)="setLogLevel('low')">Low</button>
                <button type="button" class="btn"
                        [class.btn-warning]="logLevel === 'medium'"
                        [class.btn-outline-warning]="logLevel !== 'medium'"
                        (click)="setLogLevel('medium')">Medium</button>
                <button type="button" class="btn"
                        [class.btn-danger]="logLevel === 'high'"
                        [class.btn-outline-danger]="logLevel !== 'high'"
                        (click)="setLogLevel('high')">High</button>
              </div>
              <button class="btn btn-sm btn-outline-secondary" (click)="fetchLogs()" [title]="'AKTUALISIEREN' | translate">↻</button>
            </div>

            <div class="flex-grow-1 overflow-hidden p-2">
              <div *ngIf="copiedCell" class="text-muted small mb-1">{{ 'KOPIERT' | translate }}</div>
              <div *ngIf="logs.length === 0" class="text-muted small text-center py-3">{{ 'KEINE_EINTRAEGE' | translate }}</div>
              <ag-grid-angular
                *ngIf="logs.length > 0"
                [class]="darkMode ? 'ag-theme-alpine-dark' : 'ag-theme-alpine'"
                style="height:100%;"
                [rowData]="logs"
                [columnDefs]="colDefs"
                [gridOptions]="gridOptions"
                [tooltipShowDelay]="200">
              </ag-grid-angular>
            </div>

          </ng-container>

          <!-- ── Clients ── -->
          <ng-container *ngSwitchCase="'clients'">

            <div class="d-flex align-items-center gap-2 px-3 py-2 border-bottom flex-shrink-0">
              <span class="text-muted small me-auto">{{ clients.length }} {{ 'ADMIN_VERBUNDEN' | translate }}</span>
              <button class="btn btn-sm btn-outline-secondary" (click)="fetchClients()" [title]="'AKTUALISIEREN' | translate">↻</button>
            </div>

            <div class="flex-grow-1 overflow-auto p-3">
              <div *ngIf="clients.length === 0" class="text-muted small text-center py-3">{{ 'ADMIN_KEINE_VERBINDUNGEN' | translate }}</div>
              <div *ngFor="let c of clients" class="card mb-2">
                <div class="card-body p-2" style="font-size:.8rem;">
                  <div class="d-flex align-items-center gap-2 mb-1">
                    <span class="badge bg-success">🔌 {{ 'ADMIN_VERBUNDEN_BADGE' | translate }}</span>
                    <span class="fw-semibold">{{ c.ip }}</span>
                    <span class="text-muted ms-auto" style="font-size:.72rem;">seit {{ c.connectedAt | date:'dd.MM.yy HH:mm:ss' }}</span>
                  </div>
                  <div class="text-muted text-truncate" style="font-size:.72rem;" [title]="c.userAgent">{{ c.userAgent || '–' }}</div>
                  <div class="text-muted" style="font-size:.68rem; font-family: monospace;">
                    <span *ngIf="c.xRealIp">X-Real-IP: {{ c.xRealIp }}<br></span>
                    <span *ngIf="c.xForwardedFor">X-Forwarded-For: {{ c.xForwardedFor }}<br></span>
                    <span>remote: {{ c.remoteAddr }}</span>
                  </div>
                </div>
              </div>
            </div>

          </ng-container>

        </div>
      </div>

    </ng-container>
  </div>
</div>

<!-- Language Picker Overlay -->
<div *ngIf="langPickerOpen"
     style="position:fixed;inset:0;z-index:1055;display:flex;align-items:center;justify-content:center;background:rgba(0,0,0,0.5);"
     (click)="closeLangPicker()">

  <div class="bg-body shadow-lg d-flex flex-column"
       style="width:min(94vw,560px);max-height:80vh;border-radius:12px;overflow:hidden;"
       (click)="$event.stopPropagation()">

    <!-- Header -->
    <div class="d-flex align-items-center gap-2 px-3 py-2 border-bottom flex-shrink-0">
      <span class="fw-semibold me-auto">🌐 {{ 'SPRACHE' | translate }}</span>
      <button class="btn btn-sm btn-outline-secondary" (click)="closeLangPicker()">✕</button>
    </div>

    <!-- Search -->
    <div class="px-3 py-2 border-bottom flex-shrink-0">
      <input class="form-control form-control-sm" type="search"
             [placeholder]="'SUCHEN' | translate" [(ngModel)]="langSearch" autofocus>
    </div>

    <!-- Language grid -->
    <div class="overflow-auto p-2" style="display:grid;grid-template-columns:repeat(auto-fill,minmax(140px,1fr));gap:6px;">
      <button *ngFor="let l of filteredLanguages"
              class="btn btn-sm text-start d-flex align-items-center gap-2 px-2 py-2"
              [class.btn-primary]="translate.currentLang === l.code"
              [class.btn-secondary]="translate.currentLang !== l.code && supportedLangs.has(l.code)"
              [class.btn-outline-secondary]="!supportedLangs.has(l.code)"
              [style.opacity]="supportedLangs.has(l.code) ? '1' : '0.4'"
              [disabled]="!supportedLangs.has(l.code)"
              (click)="selectLang(l.code)">
        <span class="emoji-flag" style="font-size:1.3rem;line-height:1;">{{ l.flag }}</span>
        <span class="min-w-0">
          <div class="fw-semibold small text-truncate" style="line-height:1.2;">{{ l.native }}</div>
          <div class="text-muted" style="font-size:.7rem;line-height:1.2;">{{ l.name }}</div>
        </span>
      </button>
    </div>

  </div>
</div>

<!-- 24h Solar Chart Overlay -->
<div *ngIf="solarChartOpen"
     style="position:fixed;inset:0;z-index:1055;display:flex;align-items:center;justify-content:center;background:rgba(0,0,0,0.6);"
     (click)="closeSolarChart()">
  <div class="bg-body shadow-lg"
       style="width:min(92vw,1600px);max-height:92vh;border-radius:8px;overflow:hidden;"
       (click)="$event.stopPropagation()">
    <div class="d-flex align-items-center gap-2 px-3 py-2 border-bottom flex-shrink-0">
      <span class="fw-semibold">📈</span>
      <div class="btn-group btn-group-sm" role="group">
        <button *ngFor="let r of chartRanges" class="btn"
                [ngClass]="chartRange === r.key ? 'btn-secondary' : 'btn-outline-secondary'"
                (click)="setChartRange(r.key, 'solar')">{{ r.label }}</button>
      </div>
      <span *ngIf="rangeLoading" class="spinner-border spinner-border-sm text-muted" role="status"></span>
      <button class="btn btn-sm btn-outline-secondary ms-auto" (click)="closeSolarChart()">✕</button>
    </div>
    <div class="p-2 p-sm-3">
      <app-solar-chart
        [history]="solarChartHistory"
        [darkMode]="darkMode"
        [windowMs]="rangeWindowMs"
        [labelPv]="'CHART_ERTRAG' | translate"
        [labelBattery]="'AKKU' | translate"
        [labelGrid]="'CHART_NETZ' | translate"
        [labelTotal]="'VERBRAUCH' | translate"
        [labelSoc]="'AKKU_SOC' | translate">
      </app-solar-chart>
      <div class="text-muted text-center mt-1" style="font-size:.65rem;">{{ solarChartHistory.length }} {{ 'MESSPUNKTE' | translate }}</div>
    </div>
  </div>
</div>

<!-- 24h Heizung Chart Overlay -->
<div *ngIf="heizungChartOpen"
     style="position:fixed;inset:0;z-index:1055;display:flex;align-items:center;justify-content:center;background:rgba(0,0,0,0.6);"
     (click)="closeHeizungChart()">
  <div class="bg-body shadow-lg"
       style="width:min(92vw,1600px);max-height:92vh;border-radius:8px;overflow:hidden;"
       (click)="$event.stopPropagation()">
    <div class="d-flex align-items-center gap-2 px-3 py-2 border-bottom flex-shrink-0">
      <span class="fw-semibold">🔥</span>
      <div class="btn-group btn-group-sm" role="group">
        <button *ngFor="let r of chartRanges" class="btn"
                [ngClass]="chartRange === r.key ? 'btn-secondary' : 'btn-outline-secondary'"
                (click)="setChartRange(r.key, 'froeling')">{{ r.label }}</button>
      </div>
      <span *ngIf="rangeLoading" class="spinner-border spinner-border-sm text-muted" role="status"></span>
      <button class="btn btn-sm btn-outline-secondary ms-auto" (click)="closeHeizungChart()">✕</button>
    </div>
    <div class="p-2 p-sm-3">
      <app-heizung-chart
        [history]="froelingChartHistory"
        [darkMode]="darkMode"
        [windowMs]="rangeWindowMs">
      </app-heizung-chart>
      <div class="text-muted text-center mt-1" style="font-size:.65rem;">{{ froelingChartHistory.length }} {{ 'MESSPUNKTE' | translate }}</div>
    </div>
  </div>
</div>

<!-- Initial connecting overlay (before first WS connection) -->
<div *ngIf="!vs.wsConnectedOnce && !vs.reloadPending"
     style="position:fixed;inset:0;background:var(--bs-body-bg);z-index:1060;display:flex;align-items:center;justify-content:center;">
  <div class="text-center">
    <div class="spinner-border text-primary mx-auto mb-3" role="status"></div>
    <p class="text-muted small mb-0">{{ 'VERBINDUNG_WIRD_HERGESTELLT' | translate }}</p>
  </div>
</div>

<!-- Disconnect overlay (hidden when version update overlay takes over) -->
<div *ngIf="vs.wsConnectedOnce && !vs.connected && !vs.reloadPending"
     style="position:fixed;inset:0;background:rgba(0,0,0,0.55);z-index:1060;display:flex;align-items:center;justify-content:center;">
  <div class="card text-center shadow-lg p-4" style="max-width:340px;">
    <div class="spinner-border text-danger mx-auto mb-3" role="status"></div>
    <h5 class="card-title">{{ 'VERBINDUNG_UNTERBROCHEN' | translate }}</h5>
    <p class="card-text text-muted small">{{ 'VERBINDUNG_VERLOREN' | translate }}</p>
  </div>
</div>

<!-- Changelog Overlay -->
<div *ngIf="changelogOpen"
     style="position:fixed;inset:0;z-index:1055;display:flex;align-items:center;justify-content:center;background:rgba(0,0,0,0.5);"
     (click)="closeChangelog()">
  <div class="bg-body shadow-lg d-flex flex-column"
       style="width:min(96vw,640px);max-height:80vh;border-radius:8px;overflow:hidden;"
       (click)="$event.stopPropagation()">
    <div class="d-flex align-items-center gap-2 px-3 py-2 border-bottom flex-shrink-0">
      <span class="fw-semibold me-auto">{{ 'CHANGELOG' | translate }}</span>
      <button class="btn btn-sm btn-outline-secondary" (click)="closeChangelog()">✕</button>
    </div>
    <div class="overflow-auto p-3">
      <div *ngIf="changelog.length === 0" class="text-muted small text-center py-3">
        <div class="spinner-border spinner-border-sm me-2"></div>{{ 'LADE' | translate }}
      </div>
      <div *ngFor="let c of changelog" class="d-flex gap-3 py-2 border-bottom">
        <div class="flex-shrink-0 text-muted small" style="width:80px;padding-top:2px;">
          <div>{{ c.date }}</div>
          <code style="font-size:.7rem;">{{ c.hash | slice:0:7 }}</code>
        </div>
        <div class="min-w-0">
          <div class="small fw-semibold text-break">{{ c.subject }}</div>
          <div class="text-muted" style="font-size:.7rem;">{{ c.author }}</div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- API documentation overlay -->
<div *ngIf="apiDocsOpen"
     style="position:fixed;inset:0;z-index:1055;display:flex;align-items:center;justify-content:center;background:rgba(0,0,0,0.5);"
     (click)="closeApiDocs()">
  <div class="bg-body shadow-lg d-flex flex-column"
       style="width:min(96vw,760px);max-height:85vh;border-radius:8px;overflow:hidden;"
       (click)="$event.stopPropagation()">
    <div class="d-flex align-items-center gap-2 px-3 py-2 border-bottom flex-shrink-0">
      <span class="fw-semibold me-auto">🔌 API</span>
      <a class="btn btn-sm btn-outline-secondary" href="/api/openapi.json" target="_blank" rel="noopener">openapi.json</a>
      <button class="btn btn-sm btn-outline-secondary" (click)="closeApiDocs()">✕</button>
    </div>
    <div class="overflow-auto p-3">
      <p class="text-muted small">
        Read-only JSON API. The same data is also pushed live over the WebSocket
        <code>{{ location.protocol === 'https:' ? 'wss' : 'ws' }}://{{ location.host }}/ws</code>
        as <code>{{ '{' }}"type": &lt;wsType&gt;, …{{ '}' }}</code>.
        Machine-readable spec: <a href="/api/openapi.json" target="_blank" rel="noopener">/api/openapi.json</a>.
      </p>
      <p class="text-muted small">
        Every result carries its creation time: <code>/api/data/*</code> responses are wrapped in
        <code>{{ '{' }}serverTime, serverTimeIso, data{{ '}' }}</code> and every WS frame includes
        <code>serverTime</code> / <code>serverTimeIso</code> (epoch&nbsp;ms + ISO-8601, Europe/Berlin),
        so you always know how fresh the data is.
      </p>

      <div class="fw-semibold small mt-3 mb-1">{{ 'Daten' }} · <code>/api/data</code></div>
      <div *ngIf="apiResources.length === 0" class="text-muted small py-2">
        <div class="spinner-border spinner-border-sm me-2"></div>{{ 'LADE' | translate }}
      </div>
      <div class="table-responsive" *ngIf="apiResources.length">
        <table class="table table-sm align-middle" style="font-size:.8rem;">
          <thead><tr><th>Endpoint</th><th>WS type</th><th>Beschreibung</th></tr></thead>
          <tbody>
            <tr *ngFor="let res of apiResources">
              <td class="text-nowrap"><a [href]="res.url" target="_blank" rel="noopener"><code>{{ res.url }}</code></a>
                  <span *ngIf="res.auth" class="badge bg-warning text-dark ms-1" title="benötigt Admin-Token">🔒</span></td>
              <td><code *ngIf="res.wsType">{{ res.wsType }}</code></td>
              <td>{{ res.description }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="fw-semibold small mt-3 mb-1">{{ 'Weitere Endpunkte' }}</div>
      <table class="table table-sm align-middle" style="font-size:.8rem;">
        <tbody>
          <tr><td class="text-nowrap"><code>/api/data</code></td><td>Katalog aller Datenressourcen.</td></tr>
          <tr><td class="text-nowrap"><code>/api/history?series=&amp;from=&amp;to=&amp;buckets=</code></td><td>Heruntergerechnete Langzeit-Historie einer Serie.</td></tr>
          <tr><td class="text-nowrap"><code>/api/hourly?date=YYYY-MM-DD</code></td><td>Stündliche Energiedaten eines Tages.</td></tr>
          <tr><td class="text-nowrap"><code>/api/changelog</code></td><td>Letzte Git-Commits.</td></tr>
          <tr><td class="text-nowrap"><code>/api/health</code></td><td>Health-Check.</td></tr>
          <tr><td class="text-nowrap"><code>/api/openapi.json</code></td><td>Maschinenlesbare OpenAPI-3-Spezifikation.</td></tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<!-- Version update overlay (shared with Claudia) -->
<app-version-overlay></app-version-overlay>
